import { useNavigate } from "react-router-dom";
import { Btn, EmptyState } from "../components/ui";

/** Placeholder for screens not yet ported in Phase 1. */
export function Fallback({ name }: { name: string }) {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 700, margin: "80px auto", textAlign: "center", padding: 24 }}>
      <EmptyState icon="wrench" title={name + " — in Arbeit"} sub="Dieser Bereich wird gerade gebaut." />
      <Btn variant="ghost" icon="arrow-left" onClick={() => navigate("/")}>
        Zurück
      </Btn>
    </div>
  );
}
